module.exports = __webpack_public_path__ + "static/img/tuoyuan_t.0e5c50f4.png";